import { ApiQuoteResponse } from '@bhtp-client-api/base';
import { ModalOptions } from './modal-options.model';

export class CoverageModalOptions extends ModalOptions {
    public product: ApiQuoteResponse[] = null;
    public wasPurchased: boolean = false;
    public showDocLink: boolean = false;
    public showPackageModalHeader: boolean = true;
    public showHeader: boolean = true;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/models/coverage-modal-options.model.ts